import type { StylesRegistry } from '../../EdgeDocsCore/models/styles';

let _registry: StylesRegistry | null = null;

export function setStylesRegistry(registry: StylesRegistry): void {
  _registry = registry;
}

export function getStylesRegistry(): StylesRegistry {
  if (!_registry) {
    // Provide a minimal default registry to avoid null checks during early wiring
    _registry = { characterStyles: {}, paragraphStyles: {} } as StylesRegistry;
  }
  return _registry;
}











































